export function getEventName(event) {
    return (event === null || event === void 0 ? void 0 : event.eventName) || "";
}
//# sourceMappingURL=getEventName.js.map